<template>
  <div class="next-room" v-if="isOpen">
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label for="adults">{{ $t("adults") }}</label>
          <select name="adults" class="form-select form-control-sm" v-model="adults">
            <option v-for="optionAdults in optionsAdults" v-bind:key="optionAdults.value">
              {{ optionAdults.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-6" v-for="(select, index) in childAges" :key="`ageSelect-${index}`">
        <div class="form-group">
          <label for="childrenages">{{ $t("childrenage") }} {{ index + 1 }}</label>
          <select @change="changeSelect(select, childAges, index)" v-model="select.age" name="childrenages"
            class="form-select form-control-sm">
            <option v-for="optionChildren in optionsChildrens" :key="optionChildren.value"
              :value="optionChildren.value">
              {{ optionChildren.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12 col-md-auto">
      <button :class="[this.startDate && this.endDate ? 'btn btn-primary btn-next' : 'btn btn-secondary disabled']"
        @click="searchRequestParams">
        {{ $t("search") }}
      </button>
    </div>
    </div>
  </div>
  <div class="row mb-4">

    <div class="cols-12 col-md-auto">
      <button class="btn btn-primary" v-if="!isOpen" @click="isOpen = !isOpen;">
        {{ $t("moore-rooms") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    startDate: Date,
    endDate: Date,
  },

  data() {
    return {
      testData: null,
      isOpen: false,
      adults: 2,
      optionsAdults: [
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" },
        { text: "5", value: "5" },
        { text: "6", value: "6" },
        { text: "7", value: "7" },
        { text: "8", value: "8" },
      ],
      childAges: [{ age: "" }],
      optionsChildrens: [
        { text: this.$t("age-of-child"), value: "" },
        { text: "0", value: "0" },
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" },
        { text: "5", value: "5" },
        { text: "6", value: "6" },
        { text: "7", value: "7" },
        { text: "8", value: "8" },
        { text: "9", value: "9" },
        { text: "10", value: "10" },
        { text: "11", value: "11" },
        { text: "12", value: "12" },
        { text: "13", value: "13" },
        { text: "14", value: "14" },
      ],
    };
  },
  methods: {
    changeSelect(value, fieldType, idx) {
      if (fieldType.length == idx + 1) {
        fieldType.push({ age: "" });
      }
      if (value.age == "" && fieldType.length > 1) {
        fieldType.splice(idx, 1);
      }
    },

    searchRequestParams() {
      // ?dateFrom=2021-06-01&dateTo=2021-06-05&adults=1&children=2;3;4

      //if (this.startdate && this.enddate) {

      var start = this.startDate;
      var end = this.endDate;
      var a = [];
      this.childAges.forEach((item) => {
        a.push(item.age);
        console.log(a);
      });
      var childrenPrams = a.filter(function (value) {
        return value != "";
      });

      //console.log(childrenPrams.join(";"));
      //this.SetDates(start, end);
      this.params = {
        dateFrom: start,
        dateTo: end,
        adults: this.adults,
        children: childrenPrams.join(";"),
        clearbasket: "false"
      };

      this.$emit("searchRooms", this.params);
      this.isOpen = !this.isOpen;
      this.testData = this.params;
    },
  },
};
</script>